import React from "react";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import styles from "./toggle.module.scss";
const switchStyles = (status, side) => {
    const border = styles[`border-${side}`];
    const style = styles[status];
    return [border, style].join(" ");
};
const Toggle = ({ id, label, firstValue, secondValue, active, onChange, }) => {
    return (React.createElement(Box, { id: id, sx: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
        } },
        React.createElement("span", { className: styles.label }, label),
        React.createElement(Box, null,
            React.createElement(ButtonBase, { className: switchStyles(!active ? "active" : "disabled", "left"), onClick: () => onChange(!active) },
                React.createElement("span", null, firstValue)),
            React.createElement(ButtonBase, { className: switchStyles(active ? "active" : "disabled", "right"), onClick: () => onChange(!active) },
                React.createElement("span", null, secondValue)))));
};
export default Toggle;
//# sourceMappingURL=Toggle.js.map